import { useState, useContext, useCallback } from 'react';
import type { UseModalProps } from '@trinity/chat-components/components/Modal/index.js';
import { Modal, Header, useModal } from '@trinity/chat-components/components/Modal/index.js';
import Button from '@trinity/chat-components/components/presentation/Button/index.js';
import { Textarea } from '@trinity/chat-components/components/presentation/Textarea.js';;
import { TranscriptReplacementsContext } from '@/containers/Project.Terms/Context';
import type { TranscriptHighlight } from '@/containers/Project.Terms/interfaces';
import styles from './style/Highlights.EditModal.module.css';

type Props = UseModalProps & {
  highlight: TranscriptHighlight;
};

export const EditModal = ({ highlight, ...props }: Props) => {
  const [replacement, setReplacement] = useState(highlight.rawHighlight);
  const { addReplacements } = useContext(TranscriptReplacementsContext);

  const onSave = useCallback(() => {
    addReplacements([{
      replacementText: replacement,
      expectedText: highlight.rawHighlight,
      docPos: highlight.highlightDocPos,
      tsStart: highlight.highlightTimePos.fromTs,
      transcriptId: highlight.transcript.id,
    }]);
    props.onClose();
  }, [addReplacements, highlight.highlightDocPos, highlight.highlightTimePos.fromTs, highlight.rawHighlight, highlight.transcript.id, props, replacement]);

  return (
    <Modal {...props}>
      <Header>Replace Text</Header>
      <div className={styles.section}>
        <div className={styles.label}>Selection:</div>
        <Textarea value={highlight.rawHighlight} disabled={true} />
      </div>
      <div className={styles.section}>
        <div className={styles.label}>Replace with:</div>
        <Textarea value={replacement} onChange={e => setReplacement(e.target.value)} />
      </div>
      <div className={styles.btns}>
        <Button
          variant='brick'
          color='destructive'
          onClick={props.onClose}>Cancel
        </Button>
        <Button
          variant='brick'
          color='primary'
          onClick={onSave}>Save
        </Button>
      </div>
    </Modal>
  );
};

export const useEditModal = () => useModal(EditModal);